<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11yL1Eo/tc-custom/9781504056106.jpg?1697781468271" alt="This image is the cover for the book Jared Kimberlain Novels, The Jared Kimberlain Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jared Kimberlain Novels, The Jared Kimberlain Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A pair of techno-thrillers featuring a special-forces op—from the <i>USA Today</i>–bestselling author and “one of the best all-out action writers in the business” (<i>Los Angeles Review of Books</i>).</b><br/>  <br/> “Nobody writes action like Jon Land,” and in his Jared Kimberlain thrillers, the action is truly nonstop (John Lescroart). James Rollins says: “Jon Land proves yet again that suspense has a new king.”<br/>  <br/><i>The Eighth Trumpet</i>: When the world’s finest security systems fail to protect three of the nation’s most powerful businessmen—one is electrocuted, one blown up in his sleep, a third hacked to death—Jared Kimberlain, the government’s most feared special-forces operative, must come out of retirement to protect the president of the United States, who may be the next target. Soon Kimberlain finds himself facing an army of super-killers led by a madman.<br/>  <br/><i>The Ninth Dominion</i>: Jared Kimberlain is on the hunt for a serial killer named Tiny Tim—who executes entire towns—and an asylum’s worth of escaped convicts, including Kimberlain’s old nemesis, the vicious psychopath, Andrew Harrison Leeds.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Land
      </h2>
      
      <p class="authorDescription body article">Jon Land is the <I>USA Today</I>&ndash;bestselling author of <I>The </I><I>Tenth Circle</I>,<I> Pandora&rsquo;s Temple</I> (winner of the 2012 International Book Award and nominated for a 2013 Thriller Award for Best E-Book Original Novel), and five other books featuring Blaine McCracken, Land&rsquo;s iconic series hero, for Open Road Integrated Media. He also pens the critically acclaimed Caitlin Strong series, which includes <I>Strong Rain Falling</I> and <I>Strong Darkness</I>, winners of the USA Best Book Award in 2013 and 2014, in the Mystery and Thriller categories, respectively. Now with thirty-seven books to his credit,&#160;Land will soon be working on a new title for Open Road, in which McCracken teams up with Land&rsquo;s other bestselling series hero, Jared Kimberlain (<I>The Eighth Trumpet </I>and<I> The Ninth Dominion</I>).&#160;Land lives in Providence, Rhode Island, and can be found at jonlandbooks.com and on Twitter with the handle @jondland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?92e972c4